module.exports = __webpack_public_path__ + "img/banner_768.92837419.jpg";